import { ReactElement } from "react";
import { HubManagementDialogContentLayout } from "../HubManagementDialogContentLayout";
import { localize } from "client_legacy/ndaw/culture";
import { AlertBar } from "client/Components";

export type CommunitiesContentProps = {
	isMobile: boolean;
	isResponsive: boolean;
};

export const CommunitiesContent = (props: CommunitiesContentProps): ReactElement => {
	const {
		isMobile,
		isResponsive
	} = props;

	return (
		<HubManagementDialogContentLayout
			title={localize("_Communities")}
			isMobile={isMobile}
			isResponsive={isResponsive}
			trackingId="communities-content"
		>
			<AlertBar
				isInline
				kind="info"
				isDismissable={false}
			>
				{localize("_HubManagementCommunitiesMessage")}
			</AlertBar>
		</HubManagementDialogContentLayout>
	);
};
CommunitiesContent.displayName = "CommunitiesContent";
